module.exports = __webpack_public_path__ + "img/union-member-tips.4f8cec93.svg";